import React, {useState } from 'react'
import { Typography , Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from '../api/axios'
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select'
import EditSeminarDialog from './EditSeminarDialog';

const useStyles = makeStyles((theme) => ({
	wrapper: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto",
        marginTop: '150px'
	},
    marginTop: {
        marginTop: '10px;'
    },
    paddingTopBottom: {
        paddingTop: '20px;',
        paddingBottom: '20px;'
    },
    searchIcon: {
		paddingTop: 5,
	},
	searchInput: {
		paddingLeft: 10,
		paddingTop: 5,
	},
    searchContainer: {
        border: "solid 1px black",
        borderRadius: "5px",
        marginBottom: "15px",
        minHeight: "56px"
    }
})); 


const ListSeminars = ({seminars, isAuth, fetchSeminars, getToken, host, city, academicYear, formatDate}) => {
    const classes = useStyles();
    const [openDeleteSeminar, setOpenDeleteSeminar] = useState(null);

    const [openEditSeminar, setOpenEditSeminar] = useState(false);
    const [editExistingSeminar, setEditExistingSeminar] = useState({ id: "", title:"", host:"", city:"",  number: "", link:"", audience: "", cancelled:"", date: null, end_date: null, date_time:"", academic_year: "", description:""});

    const [searchTerm, setSearchTerm] = useState("");

    const [hostValue, setHostValue] = useState("");
    const [cityValue, setCityValue] = useState("");
    const [yearValue, setYearValue] = useState("");

    const handleOpenEdit = () => setOpenEditSeminar(true);

    const deleteSeminar = () => {

        const options = {
            url: `/seminars/delete-seminar/${openDeleteSeminar}`,
            method: 'delete',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchSeminars();
            })
        .catch((error) => { console.log(error); });
    }

    const changeExistingSeminar = (seminar) => {

        if(seminar.link === null){
            seminar.link = "";
        }

        if(seminar.date_time === null){
            seminar.date_time = "";
        }

        let exSemdate = seminar.date;
        let exSemEndDate = seminar.end_date;

        if(exSemdate instanceof Date) {
            exSemdate = seminar.date.toISOString().split('T')[0]
        }

        if( exSemEndDate instanceof Date) {
            exSemEndDate = seminar.end_date.toISOString().split('T')[0]
        }

        const options = {
            url: `/seminars/edit-seminar/${seminar.id}`,
            data: {
                title: seminar.title, 
                host: seminar.host, 
                city: seminar.city,  
                number: seminar.number, 
                link: seminar.link, 
                audience: seminar.audience, 
                cancelled: seminar.cancelled, 
                date: exSemdate,
                end_date: exSemEndDate,
                date_time: seminar.date_time,
                academic_year: seminar.academic_year,
                description: seminar.description
            },
            method: 'patch',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchSeminars();
            })
        .catch((error) => { console.log(error); });
    }

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    }

    const toSortableNumber = (str) => {

        var thenum = str.replace( /^\D+/g, '');

        if(!thenum){
        
            return 1000;
        }

        thenum = parseInt(thenum);

        if(str.indexOf('WS') > -1){
            return thenum - 0.5;
        }
        return thenum;
    }

    const sortedYear = academicYear.sort(function(a, b){

            let A = toSortableNumber(a);
            let B = toSortableNumber(b);

            if(A > B){
                return -1;
            } 
            if(A < B){
                return 1;
            }
            return 0;
    });

    const sortedSeminars = seminars.sort((a, b) => {

        const dateA = a.date ? a.date : "1800-01-01"
        const dateB = b.date ? b.date : "1800-01-01"

        if(dateA > dateB){
            return -1;
        } 
        if(dateA < dateB){
            return 1;
        }
        return 0;
    })

    const filtered = sortedSeminars.filter((seminar) =>{
        let isVisible = true;
        
        if( isVisible && hostValue ){
            isVisible = seminar.host !== null && seminar.host.toLowerCase().includes(hostValue.toLowerCase())
        }

        if(isVisible && cityValue ){
            isVisible = seminar.city !== null && seminar.city.toLowerCase().includes(cityValue.toLowerCase())
        }
        
        if(isVisible && yearValue  ){
            isVisible = seminar.academic_year !== null && seminar.academic_year.toLowerCase().includes(yearValue.toLowerCase())
        }

        if( isVisible && searchTerm ){
          isVisible = seminar.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (seminar.host !== null && seminar.host.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.city !== null && seminar.city.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.number !== null && seminar.number.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.link !== null && seminar.link.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.audience !== null && seminar.audience.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.cancelled !== null && seminar.cancelled.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.date !== null && seminar.date.toLowerCase().includes(searchTerm.toLowerCase()))  ||
          (seminar.end_date !== null && seminar.end_date.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.date_time !== null && seminar.date_time.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (seminar.academic_year !== null && seminar.academic_year.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        return isVisible;
      }
    )

    return (

    <>

        <>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <Grid container className={classes.searchContainer} alignItems="center">
                        <Grid item  xs={11}>
                            <InputBase
                                placeholder="Suchen"
                                className={classes.searchInput}
                                onChange={handleSearch}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={1} className={classes.searchIcon}>
                            <SearchIcon fontSize="small" color="primary"/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl sx={{ minWidth: 200, width: "100%" }} >
                        <InputLabel id="host-select-label">Veranstalter</InputLabel>
                        <Select
                            labelId="host-select-label"
                            id="host-select"
                            value={hostValue}
                            label="Veranstalter"
                            onChange={(e) => {
                                setHostValue(e.target.value);
                            }}
                        >
                        <MenuItem
                            key={0}
                            value={''}
                            >
                            Alle anzeigen
                        </MenuItem>
                        {host.map((item, index) => (
                            <MenuItem
                            key={index}
                            value={item}
                            >
                            {item}
                            </MenuItem>
                        ))}
                            
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl sx={{ minWidth: 200,  width: "100%"}} >
                        <InputLabel id="city-select-label">Ort</InputLabel>
                        <Select
                            labelId="city-select-label"
                            id="city-select"
                            value={cityValue}
                            label="Ort"
                            onChange={(e) => {
                                setCityValue(e.target.value);
                            }}
                        >
                        <MenuItem
                            key={0}
                            value={''}
                            >
                            Alle anzeigen
                        </MenuItem>
                        {city.map((item, index) => (
                            <MenuItem
                            key={index}
                            value={item}
                            >
                            {item}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl sx={{ minWidth: 200,  width: "100%"}} >
                        <InputLabel id="year-select-label">Studienjahr</InputLabel>
                        <Select
                            labelId="year-select-label"
                            id="year-select"
                            value={yearValue}
                            label="Studienjahr"
                            onChange={(e) => {
                                setYearValue(e.target.value);
                            }}
                        >
                        <MenuItem
                            key={0}
                            value={''}
                            >
                            Alle anzeigen
                        </MenuItem>
                        {sortedYear.map((item, index) => (
                            <MenuItem
                            key={index}
                            value={item}
                            >
                            {item}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </>
        
        
        { filtered.map((seminar, index) => (
            <Accordion key={seminar.id} className={classes.marginTop}>
                <AccordionSummary >
                    <Grid container spacing={2} >
                        {isAuth ? 
                        <>
                            <Grid item xs={12} md={8}>   
                                <Typography>
                                    {seminar.title}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={2}>   
                                <Button variant="outlined" onClick={() => {
                                    handleOpenEdit();
                                    setEditExistingSeminar({...seminar});
                                }} startIcon={<EditIcon />}>
                                    Bearbeiten
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={2} >   
                                <Button 
                                    onClick={() => {setOpenDeleteSeminar(seminar.id)}}
                                    variant="outlined"  
                                    startIcon={<DeleteForeverIcon />} 
                                >
                                    Löschen
                                </Button>
                            </Grid>
                        </>
                        : 
                            <Grid item xs={12} >   
                                <Typography>
                                    {seminar.title}
                                </Typography>
                            </Grid>
                        }
                        { seminar.host ?
                            <Grid item xs={6} md={3} >
                                <Typography >
                                    Veranstalter:
                                </Typography>
                                <Typography>
                                    {seminar.host}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.city ?
                            <Grid item xs={6} md={3} >
                                <Typography >
                                    Ort:
                                </Typography>
                                <Typography >
                                {seminar.city}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.number ?
                            <Grid item xs={6} md={3} >
                                <Typography >
                                    LV-Nr./Anmeldung:
                                </Typography>
                                <Typography >
                                    {seminar.number}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.link ?
                            <Grid item xs={12} md={3}>

                                <Button variant="outlined"
                                    href={seminar.link}
                                    target="_blank"
                                >
                                    Anmeldelink
                                </Button>
                                
                            </Grid>
                            :
                            ""
                        }
                    </Grid>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                <Grid container spacing={2} >
                        { seminar.audience ?
                            <Grid item xs={12} >   
                                <Typography >
                                    Zielgruppen:
                                </Typography>
                                <Typography>
                                    {seminar.audience}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.cancelled ?
                            <Grid item xs={12} >
                                <Typography >
                                    Status: {seminar.cancelled}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.date && !seminar.date_time ?
                            <Grid item xs={12} >
                                <Typography >
                                    Start-Datum: {formatDate(seminar.date)}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.end_date && !seminar.date_time  ?
                            <Grid item xs={12} >
                                <Typography >
                                    End-Datum: {formatDate(seminar.end_date)}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.date_time ?
                            <Grid item xs={6} md={12} >
                                <Typography >
                                    Datum und Uhrzeit:
                                </Typography>
                                <Typography >
                                    {seminar.date_time}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.academic_year ?
                            <Grid item xs={12} >
                                <Typography >
                                    Studienjahr:  {seminar.academic_year}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { seminar.description ?
                            <Grid item xs={12} >
                                <Typography style={{ whiteSpace: 'pre-wrap' }} >
                                    Beschreibung:  {seminar.description}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
        ))}
        <Dialog
            open={ openDeleteSeminar !== null }
            onClose={() => {setOpenDeleteSeminar(null)}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Fortbildung löschen"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Sind Sie sicher, dass Sie die Fortbildung löschen möchten?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() => {
                setOpenDeleteSeminar(null);
                deleteSeminar();
            }
            }>löschen</Button>
            </DialogActions>
        </Dialog>
        <EditSeminarDialog
            isDialogOpen={openEditSeminar}
            setIsDialogOpen={setOpenEditSeminar}
            editSeminar={editExistingSeminar}
            setEditSeminar={setEditExistingSeminar}
            saveCallback={changeExistingSeminar}
            autoCompletes={{hosts: host, cities: city}}
        />    

    </>
    );
}

export default ListSeminars;